import type { MonospaceUserOrgRole } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';

// Single organization role assignment for a MonospaceUser.
// Consumed via the `orgRole` include on MonospaceUser
export const UserOrgRole = RStoreSchema.withItemType<MonospaceUserOrgRole>().defineCollection({
	name: 'MonospaceUserOrgRole',
	scopeId: 'monospace-default',
	getKey: (item) => item.userId,
	meta: {
		defaultFields: ['userId', 'orgRoleId'],
	},
});
